import { ObservableArray, View } from "binder"
import { PersonnelSearchableSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { CollectingRequestsViewModel, CollectionItem, PackageCollection } from "./collectingRequests-viewModel"

export class CollectingRequestsView extends View<CollectingRequestsViewModel>{
    GetViewUniqueId(): string {
        return "V-4FB4B996-D995-4357-8E8B-B570974051FB"
    }
    loadHtml(): string {
        let element = require('./collectingRequests.html').default;
        let style = require('./collectingRequests.less');
        return element;
    }
    constructor() {
       super();
    }

    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName; } private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set isLoadingUncollected(v: boolean) { this._isLoadingUncollected = v; } public get isLoadingUncollected(): boolean { return this._isLoadingUncollected;} private _isLoadingUncollected: boolean;
    public set packageCollections(v: ObservableArray<PackageCollection>) { this._packageCollection = v; } public get packageCollections(): ObservableArray<PackageCollection> { return this._packageCollection; } private _packageCollection: ObservableArray<PackageCollection>;
    public set uncollectedPackageItems(v: ObservableArray<CollectionItem>) { this._uncollectedPackageItems = v; } public get uncollectedPackageItems(): ObservableArray<CollectionItem> { return this._uncollectedPackageItems;} private _uncollectedPackageItems: ObservableArray<CollectionItem>;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    public set personnelSelector(v: PersonnelSearchableSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchableSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSearchableSelectorViewModel;    
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set selectAll(v: boolean) { this._selectAll = v; } public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;
    
    async createCollection() {
        this.dataContext.createCollection(false);
    }
    
    async createAndPrintCollection() {
        this.dataContext.createCollection(true);
    }
    
    async loadCollection() {
        this.dataContext.loadCollection();
    }
    
    async loadUncollectedItems() {
        this.dataContext.loadUncollectedItems();
    }
}
